<template>
  <div>
      <div class="complete-nameplate" v-if="0 < value.hangingDolls.length">
          <h2 class="complete-nameplate__heading">
            <template v-if="$route.path.match(/gogatsu/)">【早期ご購入（1月31日まで）特典】つるし飾りを選択してください</template>
            <template v-else>【年内ご購入特典】つるし雛を選択してください</template>
          </h2>

          <v-nameplate-hanging v-model="value"/>
      </div>

      <div class="complete-nameplate">

          <h2 class="complete-nameplate__heading">
              <template v-if="$route.path.match(/gogatsu/)">名前札、または名前旗に記載するお名前、生年月日をご入力ください。</template>
              <template v-else>名前札、または名前旗に記載するお名前、生年月日をご入力ください。</template>
          </h2>

          <div class="complete-nameplate__description">
              <template v-if="$route.path.match(/gogatsu/)">
                  <p>ひととえよりお祝いとして名前札をプレゼントさせていただいております。</p>
                  <p>お子様のお名前、生年月日を入力の上、名前札の種類をお選びください。</p>
                  <p>また、名前札から名前旗に変更することができます。その際にはグレードアップ特典として別途料金となります。</p>
              </template>

              <template v-else>
                  <p>ひととえよりお祝いとして名前札をプレゼントさせていただきます。</p>
                  <p>お子さまのお名前、ご生年月日を入力のうえ、種類をお選びください。</p>
                  <p>また、名前札から名前旗に変更することができます。その際にはグレードアップ特典として別途11,000円、ミニサイズは8,800円となります。（通常価格17,500円/ミニサイズ15,500円）</p>
              </template>

          </div>

          <div class="complete-nameplate__annotation">

              <template v-if="$route.path.match(/gogatsu/)">
                  <p>
                      ※漢字によっては書体が異なる場合がございます。<br>
                      ※生年月日は西暦、和暦、お好みの方法で入力してください。<br>
                  </p>
                  <p style="color: red;">※お名前旗につきましては、お届けまで2週間ほどお時間をいただきます。</p>
              </template>

              <template v-else>
                  <p>
                      ※漢字により書体が異なる場合があります。
                  </p>
                  <p style="color: red;">※お名前旗につきましては、お届けまで2週間ほどお時間をいただきます。</p>
              </template>

          </div>

          <v-nameplate-form v-model="value"/>

          <h2 class="complete-nameplate__heading" style="margin-top: 28px;">
              名前札の種類をお選びください
          </h2>

          <v-nameplate-type v-model="value"/>
      </div>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-nameplate-form': require('@/components/nameplate-form.vue').default,
    'v-nameplate-type': require('@/components/nameplate-type.vue').default,
    'v-nameplate-hanging': require('@/components/hanging-doll.vue').default,
  },
  props: [
    'value',
  ],
  methods: {
  }
}
</script>



<style lang="scss">
.complete-nameplate {
  $e: &;
  border-radius: 7px;
  border: 1px solid $oc-gray-1;
  background-color: #faf8f7;
  margin-bottom: 32px;
  padding: 28px 20px;
  &__heading {
    font-family: $serif;
    font-size: 17px;
    font-weight: normal;
    text-align: center;
    margin-bottom: 24px;
  }
  &__description {
    font-size: 13px;
    line-height: 1.5;
  }
  &__annotation {
    font-size: 11px;
    font-weight: 400;
    line-height: 1.6;
    margin-top: 8px;
    padding-left: 2px;
    padding-right: 2px;
  }

  .nameplate-form {
    margin-top: 20px;
  }

  .nameplate-type {
    margin-top: 24px;
  }
}
</style>
